import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quoting_/emails")({
  staticData: { breadcrumb: "Emails" },
})
